import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CasesService } from '../../../cases.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IntakeUseCase } from '../../../usecase/IntakeUseCase';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import Dates from 'src/app/utilities/Dates';
import { Directive, ElementRef, HostListener} from '@angular/core';


@Component({
    selector: 'inote',
    templateUrl: './inote.component.html',
    styleUrls: ['./inote.component.scss']
})
export class InsuranceNoteComponent implements OnInit {
    note: any;
    mainForm: FormGroup;

    notificationType: any[] = [
        {name: 'Mail', value:1},
        {name: 'Email', value: 2},
        {name: 'Phone call', value: 3},
        {name: 'Fax', value: 4},
    ];
       
    constructor(private fb: FormBuilder, private route: ActivatedRoute,
        private casesService: CasesService, private intakeUseCase : IntakeUseCase, 
        private config: DynamicDialogConfig) {

        this.mainForm = fb.group({
            id:[],
            username:[],
            noteCreatedOn:[],            
            comments:[null, Validators.required],
            notifiedBy:[null, Validators.required],
            eventDate:[null, Validators.required],
        });
    }

    get valid() : boolean {
        return this.mainForm.valid;
    }

    ngOnInit() {
        if(this.config.data) {
            this.mainForm.patchValue(this.config.data);
            this.note = this.config.data;
        }
    }

    store() {
        if(this.mainForm.invalid) {
            Object.values(this.mainForm.controls).forEach(control => {
                control.markAsTouched();
            });
        }
        if(this.mainForm.valid) {
            this.intakeUseCase.appendInsuranceNote(this.mainForm.value);
            this.clean();
        }
    }

    clean() {
        this.mainForm.reset();
    }

    cancel() {
        this.intakeUseCase.closeInsuranceNote();
        this.clean();
    }

    activate() {

    }

    inactivate() {

    }
    
}


@Directive({
    selector: '[appCharacterCounter]'
  })
  
  export class CharacterCounterDirective {

    @Input() maxLength: number;
  
    constructor(private el: ElementRef) { }
  
    @HostListener('input', ['$event.target'])
    onInput(textArea: HTMLTextAreaElement): void {
      if (textArea.value.length > this.maxLength) {
        textArea.value = textArea.value.substring(0, this.maxLength);
      }
    }
  }